import { Component, OnDestroy, OnInit } from '@angular/core';
import { DepartmentService } from '../services/department.service';
import { Subscription, tap } from 'rxjs';
import { EventService } from '../services/event.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
    windowScrolled = false;
    getDepartments: Subscription;
    departments: any[] = [];
    constructor(private departmentService: DepartmentService) {
        window.addEventListener('scroll', () => {
            this.windowScrolled = window.pageYOffset >= 100;
        });
    }

    ngOnInit(): void {
        this.getDepartments = this.departmentService
            .getDepartments()
            .pipe(
                tap((response) => {
                    this.departments = response;
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.getDepartments?.unsubscribe();
    }
}
